import React from 'react'
import tw from 'tailwind-styled-components'

import {cn} from '@containers/html-utils'
import IconArrow from './icon-arrow.svg'
import {Position} from './tooltip-position'

const TwContainer = tw.div<{$dark?: boolean; $paddings?: 12 | 16}>`
  flex
  items-center
  justify-center
  rounded-8

  ${p => (p.$dark ? 'bg-grey-d40' : 'bg-grey-l80')}
  ${p => (p.$paddings === 16 ? 'p-16' : 'px-8 py-12')}
`

interface Props {
  children?: React.ReactNode | string
  className?: string
  arrowPosition?: Position | 'up-left'
  dark?: boolean
  paddings?: 12 | 16
}

export const TooltipContainer = (props: Props) => {
  const {children, className, arrowPosition, dark = false} = props
  const {paddings = 12} = props

  return (
    <div>
      <TwContainer
        className={cn(className, 'shadow-tooltip')}
        $dark={dark}
        $paddings={paddings}
      >
        {children}
      </TwContainer>
      <ToolTipSquare arrowPosition={arrowPosition} dark={dark} />
    </div>
  )
}

const TwSquare = tw.div<{$dark?: boolean}>`
  absolute
  ${p => (p.$dark ? 'text-grey-d40' : 'text-grey-l80')}
  h-16
`

type ToolTipSquareType = {
  arrowPosition?: Position | 'up-left'
  dark?: boolean
}
const ToolTipSquare = ({arrowPosition, dark}: ToolTipSquareType) => {
  if (arrowPosition === 'left') {
    return (
      <TwSquare style={{top: 'calc(50% - 8px)', left: '-6px'}} $dark={dark}>
        <IconArrow />
      </TwSquare>
    )
  }

  if (arrowPosition === 'up') {
    return (
      <TwSquare
        $dark={dark}
        style={{
          left: 'calc(50% - 8px)',
          top: '-9px',
          transform: 'rotate(90deg)'
        }}
      >
        <IconArrow />
      </TwSquare>
    )
  }

  if (arrowPosition === 'up-left') {
    return (
      <TwSquare
        $dark={dark}
        style={{
          left: '12px',
          top: '-9px',
          transform: 'rotate(90deg)'
        }}
      >
        <IconArrow />
      </TwSquare>
    )
  }

  return null
}
